import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { IProiect } from '../../proiecte.interface';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProiecteService } from '../../proiecte.service';
import { helper } from 'src/environments/helper';
import { IUpdateContinutForm, IUpdateContinutPayload } from './continut-proiect.interface';
import { finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { Generic } from 'src/app/interfaces/generic.interface';
import { conditionalRequiredValidator, dateRangeValidator } from 'src/app/validators';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-continut-proiect',
    templateUrl: './continut-proiect.component.html',
    styleUrls: ['./continut-proiect.component.scss']
})
export class ContinutProiectComponent implements OnInit, OnChanges {
    @Input() proiect!: IProiect;
    @Input() motive!: Generic[];
    @Output() proiectChanged: EventEmitter<void> = new EventEmitter();

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;
    editorConfig!: AngularEditorConfig;

    isLoading = false;
    showEditField = false;
    passedProiectId!: number;
    form!: FormGroup;

    constructor(
        private proiecteService: ProiecteService,
        private notificationService: NotificationService,
        private fb: FormBuilder,
        public permissionsService: PermissionsService,
    ) { }

    ngOnChanges(): void {
        this.passedProiectId = this.proiect.id_proiect;
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();

        this.form = this.fb.group({
            dt_inceput: new FormControl(new Date(this.proiect?.data_inceput_reala), [Validators.required]),    // "2024-03-08T13:06:55.920Z"
            dt_finalizare: new FormControl(new Date(this.proiect?.data_finalizare_reala), [Validators.required]), // "2024-03-29T13:06:55.920Z"
            motiv_delay: new FormControl(-1, [Validators.required, Validators.min(0)]),
            motiv_obs: new FormControl('', []), // To be verified!!!!
            observatii: new FormControl(this.proiect?.description, [Validators.required]), // "<p>Descriere<br/><p>"
        }, {
            validators: [
                conditionalRequiredValidator('motiv_obs', 'motiv_delay', 0),
                dateRangeValidator('dt_inceput', 'dt_finalizare')
            ]
        });
    }

    submitForm() {
        this.isLoading = true;

        const {
            dt_inceput,
            dt_finalizare,
            motiv_delay,
            motiv_obs,
            observatii,
        } = this.form.value as IUpdateContinutForm;
        const payload: IUpdateContinutPayload = {
            data_inceput: this.formatDate(dt_inceput),
            data_finalizare: this.formatDate(dt_finalizare),
            motiv_delay,
            motiv_obs: motiv_delay === 0 ? motiv_obs : "",
            observatii,
        };

        this.proiecteService
            .updateTermene(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Proiect actualizat cu succes!',
                        this.successIcon
                    ).then(() => {
                        this.proiectChanged.emit();
                        this.form.patchValue({
                            motiv_obs: '',
                        });
                        this.closeEditField();
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    toggleEditField() {
        this.showEditField = !this.showEditField;
    }

    closeEditField() {
        this.showEditField = false;
    }

    formatDate(inputDate: Date) {
        // Get the current hour
        let currentHour = inputDate.getHours();

        // Add 3 hours
        inputDate.setHours(currentHour + 3);

        return inputDate.toISOString().split('T')[0];
    }
}
